
import { useState, useEffect } from 'react';
import { supabase } from "@/lib/supabase";
import { useAuth } from "@/contexts/AuthContext";
import { useToast } from "@/hooks/use-toast";

export const useAdminStatus = (userId?: string) => {
  const { user } = useAuth();
  const { toast } = useToast();
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const targetUserId = userId || user?.id;
    
    if (!targetUserId) {
      setIsAdmin(false);
      setLoading(false);
      return;
    }

    const checkAdminStatus = async () => {
      try {
        setLoading(true);
        
        // Special check for hassaanabegam@gmail.com
        if (user?.email === "hassaanabegam@gmail.com") {
          // Ensure admin role exists for this user
          const { data: existingRole } = await supabase
            .from("user_roles")
            .select("*")
            .eq("user_id", targetUserId)
            .eq("role", "admin")
            .maybeSingle();
          
          if (!existingRole) {
            // Create admin role if it doesn't exist
            const { error: insertError } = await supabase
              .from('user_roles')
              .insert({
                user_id: targetUserId,
                role: 'admin'
              });
            
            if (!insertError) {
              console.log("Admin role created for hassaanabegam@gmail.com");
            }
          }
          
          setIsAdmin(true);
        } else {
          // Check if user has admin role
          const { data, error } = await supabase
            .from("user_roles")
            .select("*")
            .eq("user_id", targetUserId)
            .eq("role", "admin")
            .maybeSingle();

          if (error && error.code !== "PGRST116") {
            console.error("Error checking admin status:", error);
          }

          setIsAdmin(!!data);
        }
      } catch (error: any) {
        console.error("Error checking admin status:", error.message);
        setIsAdmin(false);
      } finally {
        setLoading(false);
      }
    };

    checkAdminStatus();
  }, [user, userId, toast]);

  return { isAdmin, loading };
};
